import { useSelector } from 'react-redux';
import CloseButton from 'conversations-visitor-experience-components/visitor-widget/CloseButton';
import AIPromptRecommendationsContainer from './AIPromptRecommendationsContainer';
import styled from 'styled-components';
import { getWidgetLocation } from '../selectors/widgetDataSelectors/getWidgetLocation';
import { LEFT_ALIGNED } from 'conversations-internal-schema/widget-location/constants/WidgetLocations';
import { usePromptsHeight } from '../hooks/usePromptsHeight';
import { useCustomerAgentHover } from 'conversations-visitor-experience-components/contexts/CustomerAgentHoverContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WelcomePageWrapper = styled.div.withConfig({
  displayName: "WidgetWelcomePage__WelcomePageWrapper",
  componentId: "sddvl1-0"
})(["position:relative;display:flex;flex-direction:column;align-items:", ";"], ({
  widgetLocation
}) => widgetLocation === LEFT_ALIGNED ? 'flex-start' : 'flex-end');
const WelcomePageContent = styled.div.withConfig({
  displayName: "WidgetWelcomePage__WelcomePageContent",
  componentId: "sddvl1-1"
})(["margin-top:35px;display:flex;flex-direction:column;gap:10px;"]);

//This page hosts the close button, AI prompt recommendations, quick replies, and welcome message
const WidgetWelcomePage = ({
  onClose
}) => {
  const widgetLocation = useSelector(getWidgetLocation);
  const {
    isHoverActive
  } = useCustomerAgentHover();
  // Only measure the height of the AI prompt recommendations hovering on customer agent
  const {
    height: promptsHeight,
    ref: promptsRef
  } = usePromptsHeight(isHoverActive);
  return /*#__PURE__*/_jsx(WelcomePageWrapper, {
    widgetLocation: widgetLocation,
    children: /*#__PURE__*/_jsxs(WelcomePageContent, {
      children: [/*#__PURE__*/_jsx(CloseButton, {
        onClick: onClose,
        "aria-label": "Close welcome page",
        "data-test-id": "ask-me-anything-close-button",
        widgetLocation: widgetLocation,
        promptsHeight: promptsHeight
      }), /*#__PURE__*/_jsx("div", {
        ref: promptsRef,
        children: /*#__PURE__*/_jsx(AIPromptRecommendationsContainer, {})
      })]
    })
  });
};
WidgetWelcomePage.displayName = 'WidgetWelcomePage';
export default WidgetWelcomePage;